import { TranslatableText, Translate } from '@dreryk/react-common';
import { EmptyStatePlaceholder, Link, StyledFlex } from '@dreryk/react-components';

import { FormsTemplatesRootPortal } from '../FormsTemplates.portal';
import { useFormsTemplatesContext } from '../formsTemplatesContext';
import { formsTemplatesTranslationKeys } from '../translations';

type FormsTemplatesEmptyStatePlaceholderProps = {
   readonly subheading: TranslatableText;
};

export const FormsTemplatesEmptyStatePlaceholder = (
   props: FormsTemplatesEmptyStatePlaceholderProps
): JSX.Element | null => {
   const { addNewItem, activeItem } = useFormsTemplatesContext();

   if (activeItem) {
      return null;
   }

   return (
      <FormsTemplatesRootPortal>
         <EmptyStatePlaceholder
            testId={'noMagistralDrugTemplates'}
            heading={formsTemplatesTranslationKeys.noTemplates}
            subheading={
               <StyledFlex direction={'column'} gap={'8px'}>
                  <Translate>{props.subheading}</Translate>
                  <Link testId={'addTemplate'} label={formsTemplatesTranslationKeys.addTemplate} onClick={addNewItem} />
               </StyledFlex>
            }
         />
      </FormsTemplatesRootPortal>
   );
};
